import { http } from '../../axios';
import { localContentPrefix } from '../../../config';
import { Pagination } from '../../../../models/Pagination';
import { ProductFilter, ProductsResponseOut } from '../../../store/api';
const url = `${localContentPrefix}/v1/localcollectioncontent/list/:kind`;

interface ParameterTypes {
    pagination: Pagination;
    filterMap: ProductFilter;
}
export const fetchLocalContentCollectionProducts = ({ filterMap, pagination }: ParameterTypes) => {
    return http.post<ProductsResponseOut>(url, filterMap, {
        params: {
            ...pagination
        },
        pathParams: {
            kind: 'products'
        }
    });
};
